import { flashcards } from "./flashcards"
import { diagnostic } from "./diagnostic"
import { challenges } from "./challenge"
import { lessons } from "./lessons"

export const activities = {
  flashcards,
  diagnostic,
  challenges,
  lessons,
}
